import { render, staticRenderFns } from "./PointChart.vue?vue&type=template&id=2bbec036&scoped=true&"
import script from "../../models/analysis/point-chart.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/point-chart.ts?vue&type=script&lang=ts&"
import style0 from "../../styles/analysis/analysis.scss?vue&type=style&index=0&id=2bbec036&prod&lang=scss&scoped=true&"
import style1 from "./PointChart.vue?vue&type=style&index=1&id=2bbec036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbec036",
  null
  
)

export default component.exports